import React, 
       { useEffect, 
         useState }                 from 'react';
import { Container, 
         Button,
         Row, 
         Col}                       from 'react-bootstrap';
import api                          from './AxiosConfig';
import EditFloatValue               from './EditFloatValue';
import DateDisplay                  from './DateDisplay';
import { BsFillCaretDownFill,
         BsFillCaretUpFill     }    from 'react-icons/bs';  

function GoalProgressUpdateDXY( { selGoal, refresh } ) {
  const [startRecord, setStartRecord] = useState( 0 );
  const [goal,        setGoal]        = useState();
  const [progress,    setProgress]    = useState();
  const [message,     setMessage]     = useState( "" );
  const [messageErr,  setMessageErr]  = useState( false );

 useEffect(() => {
    if (selGoal) {
        setGoal(selGoal);
        }
  }, [selGoal]); // Runs when initialData changes

  useEffect(() => {
      async function getGoalProgress() {
          if ( goal && goal.id ) {
              try {
                  const response = await api.get(`/site/goals/progress/current/${encodeURIComponent(goal.id)}`, {withCredentials: true });
                  const rawProgress = response.data;
                  var sr = 0;
                  for ( let pr of rawProgress ) {
                      if ( pr.is_measured !== 1 ) {
                          break;
                      }
                      sr = sr + 1;
                  }
                  if ( sr > 9 ) { 
                         sr = sr - 8; 
                  } else { 
                         sr = 0; 
                  }

                  for ( let p = 0; p < rawProgress.length ; p++ ) {
                      rawProgress[p].valid = true;                         
                  }
                     
                  setProgress(rawProgress);
                  setStartRecord( sr );
                     
              } catch (error) {
                  console.log("getGoalProgress: " + error);
              }
          }
      }
      // Fetch the progress record for this goal.
      getGoalProgress();
  }, [goal]); 

  const updateProgressValueAtIndex = (i, newValue, validValue) => {
      setProgress(prev =>
          prev.map((item, idx) =>
          idx === i
          ? { ...item, value: newValue, is_measured: "1", valid: validValue }   
          : item                           
          )
       );
  };    

  const checkAllInputsValid = () => {
      for ( let p = 0; p < progress.length ; p++) {
          if (progress[p].is_measured === "1" && progress[p].valid === false) {
              return false;
          }
      }
      return true;
  }
       
  const handleUpdateProgressRecord = async () => {
      try {
          if ( checkAllInputsValid() ) {
              const response = await api.put(`/site/goals/progress/${encodeURIComponent(goal.id)}`, { progress }, {withCredentials: true });
              setMessage(response.data.message);
              setMessageErr( !response.data.success);
              refresh();
          } else {
              setMessage("Ensure all entered input data is valid before submitting.");
              setMessageErr( true );
          }
      } catch (error) {
          console.log("subGoalRow: " + error);
              setMessage(error);
              setMessageErr( true );
      }
  }

  const handleButtonUp = async () => {
      if ( startRecord < 10 ) {
          setStartRecord( 0 );
      } else {
          setStartRecord( startRecord - 10 );
      }
  }

  const handleButtonDown = async () => {
      if ( startRecord < ( progress.length - 10 ) ) {
          setStartRecord( startRecord + 10 );
      } else {
          if ( progress.length < 10 ) {
              setStartRecord( 0 );
          }
      }
  }
  return (
    <Container className="mt-4">
      { goal && progress ? ( 
      <>
        {progress.map((pr, index) => 
            index >= startRecord && index < (startRecord + 10) && (
                <Row key={index} >
                    <Col className="text-end" ><DateDisplay dateVal={pr.date} /></Col> 
                    <Col><EditFloatValue index={index} boxMeasured={pr.is_measured} boxValue={pr.value} onBoxChanged={updateProgressValueAtIndex}/></Col>
                    <Col>({pr.score && pr.score.toFixed(2)})</Col>
                </Row>              
         ))}      
                <Row>
                  <Col className="text-center"><Button variant="primary" size="sm" onClick={()=> handleButtonUp()}><BsFillCaretUpFill /></Button></Col>
                  <Col className="text-center"><Button variant="primary" size="sm" onClick={() => handleUpdateProgressRecord()}>Update Progress</Button></Col>
                  <Col className="text-center"><Button variant="primary" size="sm" onClick={()=> handleButtonDown()}><BsFillCaretDownFill /></Button></Col>
                </Row>
      </> ) : ( <p>Loading data...</p> )}
      <Row><Col className={'text-center message-err-' + messageErr}>{message}</Col></Row>
    </Container>           
  );
}

export default GoalProgressUpdateDXY;
